import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { TicketReservationService } from '../../../services/ticket-reservation.service';
import { TimeService } from '../../../services/time.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-submit-reservation',
  templateUrl: './submit-reservation.component.html',
  styleUrls: ['./submit-reservation.component.scss']
})
export class SubmitReservationComponent implements OnInit {

  @Input() formInvalid: boolean;
  @Input() termsChecked: boolean;
  @Input() reservationInfo: ReservationPluginInfo;
  ticketReservation = new TicketReservationPlugin();
  @Output() confirm = new EventEmitter<TicketReservationPlugin>();

  constructor(private ticketReservationService: TicketReservationService, private timeService: TimeService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
    });
  }

  ngOnInit(): void {
  }

  makeReservation() {
    this.ticketReservationService.updateTicketReservation(this.ticketReservation);
    this.confirm.emit(this.ticketReservation);
    this.ticketReservationService.toConfirmReservation();
  }

  invalidReservation(): boolean {
    return this.formInvalid || !this.ticketReservation.categoryId || this.invalidReservationTime()
      || !this.termsChecked;
  }

  invalidReservationTime(): boolean {
    return !this.ticketReservation.reservationTime ||
      !(this.reservationInfo.availableTimes[this.ticketReservation.categoryId].availableReservations
        .find(x => this.timeService.sameTime(new Date(x.reservationTime), this.ticketReservation.reservationTime)));
  }

}
